import React from 'react';
import { Badge } from '@/components/ui/badge';


interface FormulaBadgesProps {
  name: string;
  strength?: string | null;
  exposureClass?: string | null;
  consistency?: string | null;
  granulometry?: string | null;
  size?: 'sm' | 'default';
  showName?: boolean;
}

export const FormulaBadges: React.FC<FormulaBadgesProps> = ({
  name,
  strength,
  exposureClass,
  consistency,
  granulometry,
  size = 'default',
  showName = true,
}) => {
  // Use design tokens - 'sm' uses text-label-sm, 'default' uses text-body-md
  const badgeClass = size === 'sm' ? 'text-label-sm px-sm py-0 h-5' : 'text-body-md';
  
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {showName && (
        <Badge variant="secondary" className={badgeClass}>
          {name}
        </Badge>
      )}
      {strength && (
        <Badge variant="outline" className={badgeClass}>
          {strength}
        </Badge>
      )}
      {exposureClass && (
        <Badge variant="outline" className={badgeClass}>
          {exposureClass}
        </Badge>
      )}
      {consistency && (
        <Badge variant="outline" className={badgeClass}>
          {consistency}
        </Badge>
      )}
      {granulometry && (
        <Badge variant="outline" className={badgeClass}>
          D{granulometry}
        </Badge>
      )}
    </div>
  );
};
